import { Box, Button, Typography } from "@material-ui/core";
import {
  getSession,
  getUserFromGoogleLoginResponse,
  setUser,
  State,
  User,
} from "@store";
import { GEARS_CONSTANTS } from "@utils";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { CodeResponse, useGoogleLogin as useGoogle } from "@react-oauth/google";
import { httpClient } from "@api/httpClient";

// function isGoogleLoginResponse(
//   response: GoogleLoginResponse | GoogleLoginResponseOffline
// ): response is GoogleLoginResponse {
//   return (response as GoogleLoginResponseOffline).code === undefined;
// }

export const Login: React.FC = () => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const user = useSelector((state: State) => state.user);
  const domain = process.env.REACT_APP_GOOGLE_AUTH_HOSTED_DOMAIN;
  // uses deprecated Google auth flow (DEPRECATED)
  // const Google = useGoogleLogin({
  //   //hostedDomain: domain,
  //   clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT!,
  //   scope: GEARS_CONSTANTS.GOOGLE_DIRECTORY_SCOPES,
  //   discoveryDocs: GEARS_CONSTANTS.DISCOVERY_DOCS,
  //   // isSignedIn: true,
  //   // responseType: "code",
  //   onRequest: () => setDisabled(true),
  //   onSuccess: (
  //     response: GoogleLoginResponse | GoogleLoginResponseOffline
  //   ): void => {
  //     if (isGoogleLoginResponse(response)) {
  //       dispatch(setUser(getUserFromGoogleLoginResponse(response)));
  //       dispatch(getSession());
  //     } else {
  //       // Handle offline response
  //       console.log("code", response.code);
  //     }
  //   },
  //   onFailure: () => setDisabled(false),
  // });

  // const onSignInClick = (event: React.SyntheticEvent<HTMLButtonElement>) => {
  //   event.preventDefault();
  //   Google.signIn();
  // };

  const onSignInGIS = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    GISLogin();
  };

  // updated Google Identity Services login
  const GISLogin = useGoogle({
    onSuccess: async (codeResponse: CodeResponse) => {
      try {
        setDisabled(true);
        // console.log("gis response httpClient");
        // console.log(codeResponse.code);
        const { data } = await httpClient.post<User>(
          `/api/v1/google/auth`,
          codeResponse.code
        );
        dispatch(setUser(data));
        dispatch(getSession());
      } catch (err) {
        console.log(err);
      }
    },
    onError: (err) => {
      console.log("ERROR");
      console.log(err.error_uri);
      console.log(err.error_description);
      console.log(err.error);
      console.log(err);
    },
    scope: GEARS_CONSTANTS.GOOGLE_DIRECTORY_SCOPES,
    flow: "auth-code",
  });

  let redirectPath = window.location.pathname;
  // slice first 9 characters which is (/login/r/)
  redirectPath = redirectPath.slice(9);

  let redirectAfterSuccess = null;
  //console.info("redirectPath Login:"+redirectPath);
  if (redirectPath && redirectPath != "login") {
    redirectAfterSuccess = <Redirect to={{ pathname: `/${redirectPath}` }} />;
    // console.info("redirectPath Login1:" + redirectPath);
  } else {
    redirectAfterSuccess = <Redirect to={{ pathname: `/` }} />;
    // console.info("redirectPath Login2:" + redirectPath);
  }

  return user ? (
    redirectAfterSuccess
  ) : (
    <Box
      flexGrow={1}
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography variant="h1" component="p" paragraph>
        <Box
          component="strong"
          display="block"
          fontSize="h1.fontSize"
          fontWeight="fontWeightBold"
          color="primary.dark"
        >
          {"GEARS"}
        </Box>
      </Typography>
      <Typography variant="body1" paragraph color="textSecondary">
        {"Please log in using your primary email address"}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        disabled={disabled}
        onClick={onSignInGIS}
        disableElevation
      >
        {"Log in"}
      </Button>
    </Box>
  );
};
